if (!Array.prototype.findLastIndex) {
  Array.prototype.findLastIndex = function (callback, thisArg) {
    if (this == null) {
      throw new TypeError('Array.prototype.findLastIndex called on null or undefined');
    }
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    const len = this.length >>> 0; // Convert to a number and ensure it's a valid length
    const startIndex = len - 1;

    // Iterate over the array backwards
    for (let i = startIndex; i >= 0; i--) {
      if (callback.call(thisArg, this[i], i, this)) {
        return i; // Return the index if the callback is true
      }
    }

    return -1; // Return -1 if not found
  };
}
